import PropTypes from 'prop-types';
import React, { Component } from 'react';
import loading from 'images/loading.gif';
import classNames from 'classnames';

if (process.env.NODE_ENV !== 'test') {
  require('./Loading.scss');
}

export default class ComponentLoading extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    size: PropTypes.string,
  };

  static defaultProps = {
    visible: true,
    size: '100px',
  };

  render() {
    if (!this.props.visible) return null;
    return (
      <div className={classNames('ComponentLoading')}>
        <img
          alt="Laster, vennligst vent"
          src={loading}
          style={{ width: this.props.size, height: this.props.size }}
        />
      </div>
    );
  }
}
